export const rainfallUnits = [
  {
    label: 'Millimeter',
    value: 'millimeter',
  },
  {
    label: 'Inches',
    value: 'inches',
  },
]